import { useFullStoryStore } from "@/store/fullStoryStore";
import { useCookieConsentStore } from "@/store/cookieConsentStore";

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) return;

  const cookieConsentStore = useCookieConsentStore();
  if (!cookieConsentStore.areAnalyticsCookiesEnabled) return;

  const fullStoryStore = useFullStoryStore();
  fullStoryStore.bootFullStory();
});
